import { api } from './index'

interface Error {
  status: string;
  statusText: string;
  data: any;
}

export const createWallet = async () => {
  return await api.post(`/wallet/create`).then(
    res => {
      return res.data;
    },
    error => {
      return error.response.data.message;
    }
  );
};

export const userWalletDetails = async (id: string) => {
  return await api.get(`/wallet/user/${id}`).then(
    res => {
      return res.data.Wallet;
    },
    error => {
      return error.response.data.message;
    }
  );
};
